module.exports = __webpack_public_path__ + "img/pl.b20c60f5.svg";